<template>
  <div>
    <loan-amount
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'loan-amount'"
    />
    <loan-term
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'loan-term'"
    />
    <introduce-yourself
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'introduce-yourself'"
    />
    <connect-to-bank
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'connect-to-bank'"
    />
    <repayment-account
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'repayment-account'"
    />
    <id-verification
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'id-verification'"
    />
    <residential-details
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'residential-details'"
    />
    <employment-details
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'employment-details'"
    />
    <financial-capacity
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'financial-capacity'"
    />
    <financial-capacity-2
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'financial-capacity-2'"
    />
    <financial-assets
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'financial-assets'"
    />
    <financial-liabilities
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'financial-liabilities'"
    />
    <post-settlement
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'post-settlement'"
    />
    <additional-services
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'additional-services'"
    />
    <loan-application-summary
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'loan-application-summary'"
    />
    <thank-you
      :onChangeStep="changeCurrentStep"
      v-if="this.currentStep === 'thank-you'"
    />
  
  </div>
</template>

<script>
import LoanAmount from "@components/loanApplication/LoanAmount";
import LoanTerm from "@components/loanApplication/LoanTerm";
import IntroduceYourself from "@components/loanApplication/IntroduceYourself";
import ConnectToBank from "@components/loanApplication/ConnectToBank";
import RepaymentAccount from "@components/loanApplication/RepaymentAccount";
import IdVerification from "@components/loanApplication/IdVerification";
import ResidentialDetails from "@components/loanApplication/ResidentialDetails";
import EmploymentDetails from "@components/loanApplication/EmploymentDetails";
import FinancialCapacity from "@components/loanApplication/FinancialCapacity";
import FinancialCapacity2 from "@components/loanApplication/FinancialCapacity2";
import FinancialAssets from "@components/loanApplication/FinancialAssets";
import FinancialLiabilities from "@components/loanApplication/FinancialLiabilities";
import PostSettlement from "@components/loanApplication/PostSettlement";
import AdditionalServices from "@components/loanApplication/AdditionalServices";
import LoanApplicationSummary from "@components/loanApplication/LoanApplicationSummary";
import ThankYou from "@components/loanApplication/ThankYou";

export default {
  data() {
    return {
      currentStep: "loan-application-summary",
    };
  },
  components: { LoanAmount, LoanTerm, IntroduceYourself, ConnectToBank, RepaymentAccount, 
                IdVerification, ResidentialDetails, EmploymentDetails, FinancialCapacity, 
                FinancialCapacity2, FinancialAssets, FinancialLiabilities, PostSettlement,
                AdditionalServices, LoanApplicationSummary, ThankYou },
  methods: {
    changeCurrentStep(step) {
      this.currentStep = step;
    },
  },
};
</script>

<style>
</style>
